import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getPromo } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { Props } from './CoreSaleTooltip';

export type StateProps = Pick<Props, 'isActive' | 'message'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps> = state => {
  const promo = getPromo(state, 'core_gift_sale_on_profiles');
  return {
    isActive: !!promo,
    message: promo?.message,
  };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
